/** Убирает все символы, кроме цифр */
export function sanitize(raw: string): string {
    return raw.replace(/\D/g, '');
}

export function autoFormatDate(raw: string, isDeletion: boolean): string {
    const digits = sanitize(raw);

    if (isDeletion) {
        return raw.replace(/[^0-9.]/g, '');
    }

    const day = digits.slice(0, 2);
    const month = digits.length > 2 ? digits.slice(2, 4) : '';
    const year = digits.length > 4 ? digits.slice(4, 8) : '';

    let result = day;
    if (month) result += `.${month}`;
    if (year) result += `.${year}`;
    return result;
}
